<template>

    <div v-if="subscriptionHasLegacyContracts" class="inner with-content">
        <div class="headline">
            <h1>{{$t('contracts.create-legacy.headline')}}
                <p>{{getSingleProperty.address}}</p>
            </h1>

        </div>

        <div class="upload-container">
            <div class="top">
                <h2>{{$t('contracts.create.legacy.headline')}}</h2>
                <datepicker placeholder="Select Date"></datepicker>
                <!--
                <div class="info">
                    <simple-svg
                        :filepath="'/images/SVG/Question.svg'"
                        :width="'20px'"
                        :height="'20px'"

                    />
                    <p>{{$t('contracts.create.legacy.question')}}</p>
                </div>
                -->
            </div>

            <div class="popup uploaded-files" v-if="showPopup">
                <ul>
                    <li v-for="file in queuedFiles">
                        <div class="icon">
                            <img src="/images/SVG/Pdf.svg" alt="">
                        </div>
                        <div class="info-content">
                            <p class="file-name">{{file.name}}</p>
                            <span class="size-info">{{parseFloat( parseFloat(file.size) / (1024 *1024)).toFixed(2)}} MB</span>
                        </div>
                        <div class="input-container" @click="toggle()">
                            <div>
                                <!-- <datepicker name="date" class="datepicker" v-model="file.date"></datepicker> -->
                                <form>
                                   <input type="date" v-model="file.date" @change="datesEntered" class="active" autofill="off" autocomplete="false">
                                   <p>{{$t('label.occupancydate')}}</p>
                                </form>


                            </div>
                        </div>
                        <div class="input-container">
                            <form>
                                <input type="text" v-bind:class="{ active: isActive }" v-model="file.tenant_name" v-on:keyup="queryForKeywords" autofill="off" autocomplete="false">
                                <p>{{$t('label.tenantname')}}</p>
                            </form>

                        </div>
                        <div class="delete">
                            <img src="/images/SVG/Delete.svg" alt="" @click.prevent="deleteFile(file)">
                        </div>
                    </li>
                </ul>
            </div>

            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                          @vdropzone-success="uploadSuccess"
                          @vdropzone-file-added="addFile"
                          @vdropzone-removed-file="removeFile"
                          @vdropzone-error="uploadError"
                          @vdropzone-sending="sendingFiles"></vue-dropzone>

           <div class="bottom">
                <div class="left">
                    <router-link to="/contracts#upload-kontrakt" class="back">
                        <simple-svg
                            :filepath="'/images/SVG/ArrowLeft.svg'"
                            :width="'6px'"
                            :height="'12px'"

                        />
                        <span>{{$t('button.goback')}}</span>
                    </router-link>
                </div>
                <div class="right">
                    <button class="purple" @click.prevent="uploadFiles" :disabled="!uploadFlag || uploading">
                        <span v-if="!uploading">{{$t('button.finishupload')}}</span>
                        <span v-if="uploading">{{$t('button.uploading')}}</span>
                    </button>
                </div>
            </div>

    </div>
</div>
<div v-else>
    Legacy contracts not available
</div>


</template>


<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import {mapGetters} from "vuex";
    import Datepicker from 'simple-vue-datepicker';
    export default {
        data: () => ({
            dropzoneOptions: {},
            showPopup: false,
            addedFiles: [],
            uploadFlag: false,
            uploading: false,
            isOpen: false,
            isActive: false,
            storedFilesQueue: false,
            maxFilesize: 2,
            return: {
                format: "d MMMM yyyy",
            }
        }),
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker
        },
        computed:{
            ...mapGetters([
                'getSingleProperty',
                'getToken',
                'subscriptionHasLegacyContracts'
            ]),
            queuedFiles(){
                return this.addedFiles;
            }
        },
        methods:{
            uploadError(a,b,c) {
                this.uploading = false;
                this.$refs.myVueDropzone.removeAllFiles();
                for (var i in this.storedFilesQueue) {
                    this.$refs.myVueDropzone.addFile(this.storedFilesQueue[i]);
                }
            },
            toggle: function(){
                this.isOpen = !this.isOpen;
            },
            openPopup(){
                this.showPopup = true;
            },
            goBack() {
                this.$router.go(-1);
            },
            datesEntered(){
                let self = this;
                this.uploadFlag = true;
                this.addedFiles.forEach(function (e) {
                    if(!e.date){
                        self.uploadFlag = false;
                        return false;
                    }
                })
            },
            uploadFiles(){
                this.uploading = true;
                this.storedFilesQueue = this.$refs.myVueDropzone.getQueuedFiles();
                this.$refs.myVueDropzone.processQueue();
            },
            uploadSuccess(file, response){
                let scope = this;
                setTimeout(function () {
                    scope.$refs.myVueDropzone.removeAllFiles()
                }, 2000);
                this.showPopup = false;
                this.$store.dispatch('fetchLegacyContracts', true);
                this.$store.commit('setSuccessBarMessage', this.$t('successbar.legacy-contracts.created.message'));
                this.$router.push('/contracts');
            },
            sendingFiles(file, xhr, formData){
                formData.append('property_id', this.getSingleProperty.id);
                formData.append('file_date', file.date);
                formData.append('file_tenant', file.tenant_name);
                formData.append('file_name', this.getFileName(file));
            },
            addFile(file){
                file['date'] = '';
                file['tenant_name'] = '';
                this.addedFiles.push(file);
                this.openPopup();
            },
            removeFile(file, error, xhr){
                let index = this.addedFiles.indexOf(file);
                if (index > -1) {
                    this.addedFiles.splice(index, 1);
                }
            },
            getFileName(file){
                let index = file.name.indexOf('.');
                return file.name.slice(0, index);
            },
            showError(file, message, xhr){

            },
            deleteFile(file){
                this.$refs.myVueDropzone.removeFile(file);
            },
            queryForKeywords: function(){
                this.isActive = true;
            }
        },
        created(){
            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/contract/upload',
                thumbnailWidth: 150,
                maxFilesize: 4,
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: false,
                addRemoveLinks: true,
                dictDefaultMessage: '',
                uploadMultiple: false,
                acceptedFiles: 'application/pdf'

            },
            this.dropzoneOptions.dictDefaultMessage = this.$t('upload-legacy.dropzone.text');
        }
    }
</script>

<style scoped>

</style>
